module.exports = __webpack_public_path__ + "static/media/ConcreteSection.372ec7c0.svg";